import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { makeInitDeviationXHRCall } from '../../simpleXHR/actionCreators';
import { getInitDeviationXHRCallResult } from '../../simpleXHR/selectors';
export const useExtendedDeviation = (initialDeviation)=>{
    const isAlreadyExtended = !!initialDeviation.extended;
    const dispatch = useDispatch();
    const { deviation: extendedDeviation } = useSelector(getInitDeviationXHRCallResult) || {};
    useEffect(()=>{
        if (isAlreadyExtended) {
            return;
        }
        dispatch(makeInitDeviationXHRCall(initialDeviation));
    }, [
        dispatch,
        isAlreadyExtended,
        initialDeviation
    ]);
    return (extendedDeviation === null || extendedDeviation === void 0 ? void 0 : extendedDeviation.deviationId) === initialDeviation.deviationId ? extendedDeviation : undefined;
};
export default useExtendedDeviation;

//# sourceMappingURL=useExtendedDeviation.js.map